import React from 'react';
import PropTypes from 'prop-types';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import FieldGroupAccordion from './FieldGroupAccordion';

function FieldGroupArray({ fields }) {
  const onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }
    fields.move(result.source.index, result.destination.index);
  };

  const renderFieldGroup = () => {
    return (
      <>
        {fields.map((field, index) => {
          const isDragDisabled = fields.length < 2;
          return (
            <Draggable
              key={field}
              draggableId={field}
              index={index}
              // disableInteractiveElementBlocking={false}
              isDragDisabled={isDragDisabled}
            >
              {(draggableProvided, snapshot) => {
                return (
                  <FieldGroupAccordion
                    draggableProvided={draggableProvided}
                    fieldIndex={index}
                    fieldName={field}
                    fields={fields}
                    snapshot={snapshot}
                  />
                );
              }}
            </Draggable>
          );
        })}
      </>
    );
  };
  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="sections-array-droppable">
        {(droppableProvided) => (
          <div
            ref={droppableProvided.innerRef}
            {...droppableProvided.droppableProps}
          >
            {renderFieldGroup()}
            {droppableProvided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
}

FieldGroupArray.propTypes = {
  fields: PropTypes.object,
};

export default FieldGroupArray;
